/**
 * PortalRepository — data access for PortalDefinition entities.
 *
 * Follows FERP repository pattern: constructor DI of ApolloClient,
 * encapsulates all GraphQL operations for the Portal entity.
 * UI components never import this directly — use hooks instead.
 */
import { ApolloClient, gql } from '@apollo/client/core';
import type { Portal } from '../types';
import { apolloClient } from '../../client';

const GET_PORTAL_BY_SLUG = gql`
  query GetPortalBySlug($slug: String!) {
    portalBySlug(slug: $slug) {
      id
      slug
      displayName
      domain
      authConfig
      primaryColor
      secondaryColor
      logoUrl
      status
    }
  }
`;

export class PortalRepository {
  constructor(private readonly client: ApolloClient) {}

  async getBySlug(slug: string): Promise<Portal | null> {
    const { data } = await this.client.query<{ portalBySlug: Portal | null }>({
      query: GET_PORTAL_BY_SLUG,
      variables: { slug },
    });
    return data?.portalBySlug ?? null;
  }
}

export const portalRepository = new PortalRepository(apolloClient);
